/* HTTP */

export const HTTP_CODES = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409,
  BAD_GATEWAY: 502
}

/* PASSWORD VALIDATORS */

export const PASS_MUST_INCLUDE_NUMBERS = true;
export const PASS_MUST_INCLUDE_LOWER_AND_UPPER_CASE = true;
export const PASS_MUST_INCLUDE_SPECIAL_CHAR = false;
export const PASS_MIN_LENGTH = 8;

/* PAGINATION / INFINITE SCROLL */

export const PAGE_SIZE = 15;
export const LOAD_MORE = 5;

/* BUTTON TYPES */

export const TRANSPARENT_BUTTON = 'transparent';
export const SECONDARY_BUTTON = 'secondary';
export const TERTIARY_BUTTON = 'tertiary';
export const ROUND_BUTTON = 'round';

/* DROPDOWN STYLES */

export const SECONDARY_DROPDOWN = 'secondary';

/* INPUT TYPES */

export const PASSWORD = 'password';
export const SEARCH = 'search';

/* INPUT STYLES */

export const SECONDARY_INPUT = 'secondary';


/* SELECT OPTIONS */
export const COUNTRY_OPTIONS = [
  { value: 'espana', label: 'España' },
  { value: 'mexico', label: 'México' }
];

export const CITIES_OPTIONS = ["Madrid", "Cáceres", "Trujillo", "Barcelona", "Sevilla", "Badajoz", "Mérida"];

/* PERSONAL DOCUMENT OPTIONS */
export const PERSONAL_DOCUMENT_OPTIONS = [
  { value: "DNI", label: "DNI" },
  { value: "DUI", label: "DUI" },
  { value: "IFE", label: "IFE" },
  { value: "NIE", label: "NIE" },
  { value: "CEDULA_DE_CIUDADANIA", label: "Cédula de Ciudadanía" },
  { value: "RUT", label: "RUT" },
  { value: "PASAPORTE", label: "Pasaporte" },
  { value: "OTRO", label: "Otro" },
];